




















import Vue from "vue";

import DateFormatter from "../../shared/DateFormatter";
import { MonthNames } from "../../shared/Month";

export default Vue.extend({
  name: "WidgetDatetime",
  props: {
    dateTime: Date,
    endDateTime: Date,
    hide: {
      type: Array,
      default() {
        return [];
      },
    }, //date | day | month | year | time | endtime
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      MonthNames: MonthNames,
    };
  },
  methods: {},
});
